module.exports = __webpack_public_path__ + "28404114f863d1a1d31899849416004a.svg";